import React, { createContext, useState, useContext, useEffect } from 'react';
import { BasicContextInteface } from '../interfaces/User.interface';
import { useFetch } from '../utils/FetchTemplate';
import { ISetting } from '../interfaces/Setting.interface';
import { useAuth } from './AuthContext';


const SettingContext = createContext<{
    settings: ISetting;
    setSettings?: React.Dispatch<React.SetStateAction<ISetting>>;
    fetchSettings: () => Promise<void>;
}>(
    {
        settings: {} as ISetting,
        setSettings: () => { },
        fetchSettings: () => Promise.resolve()
    }
);

export const SettingProvider: React.FC<BasicContextInteface> = ({ children }) => {

    const [settings, setSettings] = useState<ISetting>({
        profile: {
            firstName: "",
            lastName: "",
            email: "",
            role: ""
        }
    } as ISetting);

    const { loggedIn, logout, user } = useAuth();
    const { postData, getData } = useFetch()
    const fetchSettings = async () => {
        if (!loggedIn) return
        postData<Partial<ISetting>>(`/api/setting/find`, { userId: user.userId! }).then((data) => {
            setSettings(data as ISetting);
        }).catch(e => { });
    };


    useEffect(() => {
        fetchSettings();
    }, [loggedIn]);


    return (
        <SettingContext.Provider value={{ settings, setSettings, fetchSettings }}>
            {children}
        </SettingContext.Provider>
    );
};

export const useSetting = () => useContext(SettingContext);